import { Controller } from "@hotwired/stimulus"

// This controller is used to directly open the edit modal for a specific email account if the edit button is on the
// page.
export default class extends Controller {
  static get values() {
    return { emailAccountId: Number }
  }

  static get targets() {
    return ["button"]
  }

  connect() {
    if (this.hasEmailAccountIdValue) {
      const button = this.buttonTargets.find(button => button.dataset.emailAccountId === this.emailAccountIdValue.toString())
      button?.click()
    }
  }
}
